export const paths = {
    ADMIN: 'admin',
    API_SURRENDER: 'api/surrender',
    API_CLONEABLEGAME: 'api/cloneablegame',
    API_AI_FEEDBACK: 'api/ai-feedback',
    API_DELETE_GAME: 'api/deletegame',
    API_CREATEGAME: 'api/creategame',
    API_BOARD_PREVIEW: 'api/board-preview',
    API_GAME: 'api/game',
    API_GAME_HISTORY: 'api/game/history',
    API_GAME_LOGS: 'api/game/logs',
    API_GAMES: 'api/games',
    API_HEAP_SNAPSHOT: 'api/heapsnapshot',
    API_IPS: 'api/ips',
    API_METRICS: 'api/metrics',
    API_CUSTOM_CARD_LIBRARY: 'api/customcardlibrary',
    API_CUSTOM_CARD_LIBRARY_REVIEW: 'api/customcardlibrary/review',
    API_LOGOUT: 'api/logout',
    API_MAP_LIBRARY: 'api/maplibrary',
    API_MAP_LIBRARY_REVIEW: 'api/maplibrary/review',
    API_PLAYER: 'api/player',
    API_PROFILE: 'api/profile',
    API_REPLAY: 'api/replay',
    API_SPECTATOR: 'api/spectator',
    API_STATS: 'api/stats',
    API_WAITING_FOR: 'api/waitingfor',
    API_WRYBIT_STATS: 'api/wrybit/stats',
    AUTH_DISCORD_CALLBACK: 'auth/discord/callback',
    AUTOPASS: 'autopass',
    CARD_LIBRARY: 'card-library',
    CARDS: 'cards',
    CUSTOM_CARD_MAKER: 'card-maker',
    END_GAME_LOG: 'end_game_log',
    GAME: 'game',
    GAMES_OVERVIEW: 'games-overview',
    HELP: 'help',
    LOAD: 'load',
    LOAD_GAME: 'load_game',
    LOGIN: 'login',
    MAP_EDITOR: 'map-editor',
    MAP_LIBRARY: 'map-library',
    NEW_GAME: 'new-game',
    PLAYER: 'player',
    PLAYER_INPUT: 'player/input',
    PLAYER_INPUT_V2: 'player/input/v2',
    PLAYER_BOOTSTRAP_V2: 'player/input/v2/bootstrap',
    PLAYER_UNDO_V2: 'player/undo/v2',
    RESET: 'reset',
    REPLAY: 'replay',
    SPECTATOR: 'spectator',
    STATS: 'stats',
    THE_END: 'the-end',
};
